/**
 * Collection filter dropdowns: CLICK to expand (instead of the theme's
 * hover-to-expand) so the horizontal filter row behaves like "View as", AND
 * keep the open dropdown OPEN while you tick options (multi-select Colour/Size).
 *
 * Ticking an option runs CollectionFiltersForm.renderFilters(), which can
 * replace the filter blocks (their data-index changes) and drop the `.is-open`
 * class. Earlier attempts (MutationObserver / poll) raced that async; instead
 * we wrap renderFilters and re-apply `.is-open` synchronously right after it
 * finishes — deterministic, no race. Reveal itself is CSS
 * (component-modern-experiments.css). Desktop horizontal layout only.
 */
(function () {
  var openFilter = null; // name of the open filter; survives re-render

  function horizontalSidebar() {
    return document.querySelector('.halo-collection-content .page-sidebar--horizontal');
  }

  function nameOf(block) {
    var t = block.querySelector('.sidebarBlock-heading .facets__text') || block.querySelector('.sidebarBlock-heading');
    return t ? t.textContent.trim().toLowerCase() : '';
  }

  function closeAll(sidebar) {
    sidebar
      .querySelectorAll('.sidebarBlock.js-filter.is-open')
      .forEach(function (b) { b.classList.remove('is-open'); });
  }

  function reopen() {
    if (!openFilter) return;
    var sb = horizontalSidebar();
    if (!sb || sb.querySelector('.sidebarBlock.js-filter.is-open')) return; // already open
    var blocks = sb.querySelectorAll('.sidebarBlock.js-filter');
    for (var i = 0; i < blocks.length; i++) {
      if (nameOf(blocks[i]) === openFilter) { blocks[i].classList.add('is-open'); return; }
    }
  }

  // open / close (accordion + outside-click)
  document.addEventListener('click', function (e) {
    var sidebar = horizontalSidebar();
    if (!sidebar) return;

    var heading = e.target.closest('.sidebarBlock-heading');
    if (heading && sidebar.contains(heading)) {
      var block = heading.closest('.sidebarBlock.js-filter');
      if (!block) return;
      var willOpen = !block.classList.contains('is-open');
      closeAll(sidebar);
      if (willOpen) { block.classList.add('is-open'); openFilter = nameOf(block); }
      else { openFilter = null; }
      e.preventDefault();
    } else if (e.isTrusted && !sidebar.contains(e.target)) {
      // Only REAL user clicks close it. The theme fires a synthetic
      // $('.swatch-label').trigger('click') on the grid after every filter
      // render (collection-filters-form.js); without the isTrusted guard that
      // bubbles here as an "outside click" and slams the dropdown shut.
      closeAll(sidebar);
      openFilter = null;
    }
  });

  // Hook the theme's filter re-render so the open dropdown survives each tick.
  (function patch() {
    if (typeof CollectionFiltersForm === 'undefined' || !CollectionFiltersForm.renderFilters) {
      return setTimeout(patch, 200); // wait until the theme class is defined
    }
    var original = CollectionFiltersForm.renderFilters;
    CollectionFiltersForm.renderFilters = function () {
      var result = original.apply(this, arguments);
      reopen();
      return result;
    };
  })();
})();
